module.exports = __webpack_public_path__ + "img/cq2.02b870f0.jpg";